import React, { Component } from 'react';
import { connect } from 'react-redux';
import UsersView from './Users.view';

export class UsersContainer extends Component {

  constructor(props) {
    super(props);
    this.removeUser = this.removeUser.bind(this);
    this.onFormUpdate = this.onFormUpdate.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.openCreateModal = this.openCreateModal.bind(this);
    this.closeCreateModal = this.closeCreateModal.bind(this);
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch({
      type: 'FETCH_USERS'
    });
  }

  openCreateModal() {
    const { dispatch } = this.props;
    dispatch({
      type: 'TOGGLE_MODAL',
      payload: {
        active: true,
      }
    });
  }

  closeCreateModal() {
    const { dispatch } = this.props;
    dispatch({
      type: 'TOGGLE_MODAL',
      payload: {
        active: false,
      }
    });
  }

  removeUser(id) {
    const { dispatch } = this.props;
    if(confirm('Are you sure you want to delete this user?')){
      dispatch({
        type: 'REMOVE_USER',
        payload: {
          id,
        }
      });
    }
  }

  onFormUpdate(formState, actions) {
    const { dispatch } = this.props;
    dispatch({
      type: 'ON_CREATE_FORM_UPDATE',
      payload: {
        formState,
      },
    });
  }

  submitForm(formState) {
    const { dispatch } = this.props;
    dispatch({
      type: 'CREATE_USER',
      payload: {
        data: formState.data,
      },
    });
  }

  render() {
    return (<UsersView
      {...this.state}
      {...this.props}
      openCreateModal={this.openCreateModal}
      closeCreateModal={this.closeCreateModal}
      removeUser={this.removeUser}
      onFormUpdate={this.onFormUpdate}
      submitForm={this.submitForm}
    />);
  }

}

function mapStateToProps(state) {
  const { users } = state;
  return {
    users: users.users,
    createModalActive: users.createModalActive,
    formState: users.createFormState,
  };
}

export default connect(mapStateToProps)(UsersContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Users/Users.container.js